import { supabase } from "../supabase"
import { CollectionWithDetermination } from "../types"
import { useQuery } from "@tanstack/react-query"

export const getProjectCollections = async (projectId: string) => {
  const { data: collections, error } = await supabase
    .from("collections_with_current_determination")
    .select("*")
    .eq("project_id", projectId)
    .order("created_at", { ascending: false })
    .overrideTypes<CollectionWithDetermination[]>()
  if (error) throw new Error(error.message)
  // this typecast required to avoid issues with undefined properties
  return collections as CollectionWithDetermination[]
}

export const getCollectionsForProjectQueryOptions = (projectId: string) => ({
  queryKey: ["collections", "byProject", projectId],
  queryFn: () => getProjectCollections(projectId),
  refetchInterval: 1000 * 60 * 5, // 5 minutes
})

export const useCollectionsByProject = (projectId: string) => {
  return useQuery(getCollectionsForProjectQueryOptions(projectId))
}
